import {useRootStore} from '@/features/core/store/store';

function useTheme() {
  const {theme, setTheme} = useRootStore((state) => ({
    theme: state.settings.theme.name,
    setTheme: state.setTheme,
  }));

  return [theme, setTheme] as const;
}

export {useTheme};
